import { AdminSession, SessionStatus } from '@airreading/common/data';
import { ReactNode } from 'react';
import { SessionStatusChangeModal } from './session-status-change-modal';

interface CancelSessionsProps {
  sessions: AdminSession[];
  trigger: ReactNode;
  onSuccess?: () => void;
}

export const CancelSessions = ({ sessions, trigger, onSuccess }: CancelSessionsProps) => {
  return (
    <SessionStatusChangeModal
      sessions={sessions}
      trigger={trigger}
      targetStatus={SessionStatus.cancelled}
      modalTitle="Are you sure to cancel the following sessions?"
      confirmBtnLabel="Cancel sessions"
      description="All student attendance will be canceled and an email will be sent to the teacher notifying the session was canceled."
      noValidSessionsMessage="These sessions have already been canceled and cannot be canceled again."
      invalidSessionsMessage="There are {count} sessions that cannot be cancelled. Scheduled, in-progress, and completed sessions can be cancelled; already cancelled sessions are excluded."
      buttonVariant="destructive"
      onSuccess={onSuccess}
    />
  );
};
